import ContactForm from "../components/home/sections/ContactForm";

export const NO_DATE = 0;
export const DATE_IN_COLUMN = 1;
export const DATE_IN_ROW = 2;
export const DATE_INLINE = 3;
export const END_DATE = 4;
export const START_TO_END = 5;

export const SUBTITLE_LINK_INLINE = 6;

export const KEY_PHONE = "PHONE";
export const KEY_EMAIL_1 = "E-MAIL";
export const KEY_EMAIL_2 = "EMAIL";
export const KEY_LOCATION = "LOCATION";
export const KEY_GITHUB = "GITHUB";
export const KEY_LINKEDIN = "LINKEDIN";
export const KEY_PORTFOLIO = "PORTFOLIO";

export const KEY_SMALL = "SMALL";
export const KEY_LARGE = "LARGE";
export const KEY_NORMAL = "NORMAL";
export const KEY_STOPSTALK = "STOPSTALK";


export const SM_BREAKPOINT = 576;
export const MD_BREAKPOINT = 768;
export const LG_BREAKPOINT = 992;

export const KEY_HOME = 0;
export const KEY_RESUME = 1;

export const BASE = "Base";
export const INTRO = "Introduction";
export const RESUME = "My Resume";
export const HOME = "Home";
export const EDUCATION = "Education";
export const ABOUT_ME = "About Me";
export const PROJECTS = "Projects";
export const SKILLS = "Skills";
export const INTERNSHIPS = "Internships";
export const CONTACT_FORM = "Contact"

export const BASE_PATH = "/"; // process.env.PUBLIC_URL;
export const RESUME_PATH = "/my-resume";
export const HOME_PATH = "/home";
export const INTRO_PATH = "/intro";
export const EDUCATION_PATH = "/education";
export const ABOUT_ME_PATH = "/about-me";
export const PROJECTS_PATH = "/home";
export const SKILLS_PATH = "/skills";
export const INTERNSHIPS_PATH = "/internships";
export const CONTACT_FORM_PATH = "/contact";

export const RESUME_COMPONENT_NAV_ITEMS = [
	{
		title: HOME,
		path: HOME_PATH
	},
	{
		title: RESUME,
		path: RESUME_PATH
	}
];


export const HOME_COMPONENT_NAV_ITEMS = [
	{
		title: HOME,
		path: HOME_PATH
	},
	{
		title: ABOUT_ME,
		path: ABOUT_ME_PATH
	},
	{
		title: SKILLS,
		path: SKILLS_PATH
	},
	{
		title: PROJECTS,
		path: PROJECTS_PATH
	},
	{
		title: INTERNSHIPS,
		path: INTERNSHIPS_PATH
	},
	{
		title: CONTACT_FORM,
		path: CONTACT_FORM_PATH
	},
	{
		title: RESUME,
		path: RESUME_PATH
	},
];

export const resume_download_link = "";
//process.env.PUBLIC_URL + "/assets/documents/Lalit_Jain_Resume.pdf";

// export const full_page_path = BASE_PATH + "/full";
// export const mini_page_path = BASE_PATH + "/mini";
// export const paper_path = BASE_PATH + "/print";

// export const KEY_ =  "";

export const IMAGES_DIR = process.env.PUBLIC_URL + "/assets/images";

export const LOGO_PATH = process.env.PUBLIC_URL + "/assets/images/logo.png";
//"LogoMakr_7wNdr1.png";//"LogoMakr_2PcVZS.png"; //logomakr.com/7wNdr1
//"logomakr.com/7Zc7o7";//"logomakr.com/2PcVZS"; //"logomakr.com/6UtYfy";//'logomakr.com/1hXjgK';
//<link href="https://fonts.googleapis.com/css?family=Cinzel+Decorative:400,700,900|Cinzel:400,700,900|Farsan|Gruppo|Nixie+One|Nova+Round|Poiret+One" rel="stylesheet">

/*
font-family: 'Cinzel', serif;
font-family: 'Poiret One', cursive;
font-family: 'Cinzel Decorative', cursive;
font-family: 'Gruppo', cursive;
font-family: 'Nixie One', cursive;
font-family: 'Nova Round', cursive;
font-family: 'Farsan', cursive;
*/
